import styled from 'styled-components';
import D from '@assets/themes/dimensions';
import C from '@assets/themes/colors';

interface IRootProps {
  openMenu?: Boolean;
  status?: string;
  border?: boolean;
}

export const Root = styled.div`
  width: 97,8%;
  margin: 7px 10px 14px 10px;
  &.item-enter {
    opacity: 0;
  }
  &.item-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }
  &.item-exit {
    opacity: 1;
    transform: translate(0, 0)
  }
  &.item-exit-active {
    opacity: 0.01;
    transform: translate(80px, 0);
    transition: all 700ms ease-in;
  }
`;

export const Row = styled.div`
    width: 100%;
    height: 54px;
    min-height: 54px;
    cursor : pointer;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    border-radius: 5px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    flex: 1;
    position:relative;
    border: ${(props: IRootProps) => (props.border ? `1.5px solid ${C.ORANGE}` : `auto`)};
    box-sizing: border-box;
`;

export const Column = styled.div`  
    flex-direction: column;
    padding: 15.2px 20px;
    position:relative;
    &:after{
      content: " ";
      position: absolute;
      border-left: 1px rgba(32, 64, 120, 0.2) solid;
      top: 15%;
      right: 0;
      height: 60%;
      margin-top: auto;
      margin-bottom: auto;
    }
    @media (max-width: 1500px) {
      padding: 15px 15px;
    }
    @media (max-width: 1300px) {
      padding: 15px 12.5px;
    }
`;

export const ColName = styled(Column)`
  font-size: 15px;
  font-weight: 500;
  color: #122442;
  flex: 0 19 46%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: 1300px) {
    flex: 0 19 26%;
  }
`;

export const ColTags = styled(Column)`
  flex: 0 20 27%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: 1300px) {
    flex: 0 20 29%;
  }
`;

export const ColSize = styled(Column)`
  flex: 0 0 10%;
  text-align:center;
  position: relative;
   overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ColEdited = styled(Column)`
  flex: 0 0 15%;
  text-align: center;
  @media (max-width: 1500px) {
    flex: 0 0 12%;
  }
`;

export const ColDescribed = styled(Column)`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex: 0 0 2%;
  text-align:center;
  @media (max-width: 1500px) {
    flex: 0 0 2%;
  }
  @media (max-width: 1300px) {
    flex: 0 0 2%;
  }
`;

export const LabelDescribed = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: rgba(32, 64, 120, 0.5);
`;

export const ColState = styled.div`
  flex-direction: column;
  flex: 0 0 9%;
  padding: 15.2px 40px 15.5px 20px;
  font-size: 15px;
  font-weight: bold;
  color: ${(props: IRootProps) => props.status === "PUBLISHED" ? '#5ed485' : props.status === "DISABLED" ? '#c4c4c4' : '#f5bc00'};
  text-align:center;
  position:relative;
  @media (max-width: 1500px) {
    padding: 15.2px 35px 15.2px 15px;
  }
  @media (max-width: 1300px) {
      padding: 15px 12.5px;
      flex: 0 0 9%;
  }
`;


export const Label = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: rgba(32, 64, 120, 0.5);
  display: inline-block;
  margin-right: 4%;
`;

export const Text = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: #122442;
`;

export const FormatsAbsoluteContainer = styled.div`
  position: absolute;
  top: 38px;
  left: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 100;
  display: none;
  ${ColSize}:hover & {
    display: flex;
  }
`;

export const FormatsContainer = styled.div`
  margin: 1.7px 0 0;
  padding: 9px 12px 3px;
  border-radius: 2px;
  background-color: ${C.DARKEST_GRAY};
`;

export const FormatLabel = styled.div`
  padding: 0px 0px 4px 0px;
  font-family: Roboto;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARKER_WHITE};
`;


export const Tooltip = styled.div`
  position: absolute;
  top: 38px;
  left: 12.50px;
  padding: 9px 12px;
  width: auto;
  display: flex;
  z-index: 100;
  background-color: ${C.DARKEST_GRAY};
  font-size: 11px;
  font-weight: 500;
  color: ${C.DARKER_WHITE};
`;

export const IconContainer = styled.div`
  width:37px;
  height:36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  right:7px;
  margin-top: auto;
  margin-bottom: auto;
  top: 15%;
  &:hover {
    border-radius: 40px;
    background-color: ${C.LIGHTER_GRAY};
  }
  @media (max-width: 1300px) {
    right:-12px;
  }
`
